export default function getCoverThumbnail(files) {
  const file = files.find(({ type, thumbnail }) => type.startsWith('image') || thumbnail)
  if (file) return file.type.startsWith('image') ? file.url : file.thumbnail

  const video = files.find(({ type }) => ['vimeo', 'youtube'].includes(type))
  if (video) return `/api/media/thumbnail?url=${encodeURIComponent(video.url)}`

  // could not get thumbnail
  return
}
